import { atom } from "recoil";

// 医療機関マスタの医療機関edit用
export const clinicState = atom({
  key: "clinicState",
  default: {
    id: null,
    name: '',
    clinic_code: '',
    zipcode: '',
    prefecture_code: null,
    area: '',
    address: '',
    tel: '',
    fax: '',
    email: '',
    url: '',
    staff: '',
    access: '',
    special_notes: '',
    enabled: null,
    directly_booking: null,
    delivery_beforehand: null,
    notes: '',
    mon_open: null,
    tue_open: null,
    wed_open: null,
    thu_open: null,
    fri_open: null,
    sat_open: null,
    sun_open: null,
    holiday_open: null,
    open_comment: '',
    created_at: '',
    updated_at: '',
  },
});